import CMS from 'netlify-cms-app';
import uploadcare from 'netlify-cms-media-library-uploadcare';
import cloudinary from 'netlify-cms-media-library-cloudinary';

import IndexPagePreview from './preview-templates/IndexPagePreview';
import AboutPostPreview from './preview-templates/AboutPostPreview';
import EventsPostPreview from './preview-templates/EventsPostPreview';
import withStyledComponentsRendered from '../components/StyleInjector';

CMS.registerMediaLibrary(uploadcare);
CMS.registerMediaLibrary(cloudinary);

CMS.registerPreviewTemplate('index', withStyledComponentsRendered(IndexPagePreview));
CMS.registerPreviewTemplate('about', withStyledComponentsRendered(AboutPostPreview));
CMS.registerPreviewTemplate('events', withStyledComponentsRendered(EventsPostPreview));
